import { withPrefix } from 'gatsby'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'
import { createTwitterShareLink } from '../../../../../../utils/general'
import CircularButton from '../../../../../general/buttons/circular-button/CircularButton'
import {SmartLinkExternal } from '../../../../../general/link'

const ShareTwitterLink = observer(() => {
    const {uiStore: {home__share__activeOrg}} = useStore();
    const link = window.location.href + "share/" + home__share__activeOrg.slug;

    return (
        <SmartLinkExternal to={createTwitterShareLink(link)} action="Share to Twitter">
            <CircularButton
                noAction
                // action="Share to Twitter"
                // actionType='external-link'
            >
            <svg viewBox="0 0 509.84 416"><g><path d="M342.21,0c6.67,0,13.33,0,20,0,.45,.2,.89,.54,1.36,.59,24.86,2.94,46.2,13.12,64.01,30.77,1.05,1.04,3.63,1.21,5.3,.86,20.5-4.28,39.91-11.52,58.18-21.8,1.2-.67,2.51-1.14,4.55-2.05-8.12,24.29-22.85,42.3-43.05,56.35,19.62-1.86,38.12-7.52,57.28-15.24-13.87,20.46-29.63,37.27-48.4,51.18-2.86,2.12-3.92,4.31-3.74,7.9,1.06,20.9-.8,41.65-4.79,62.13-11.52,59.08-37.16,111.21-78.57,155.11-46.79,49.6-104.41,78.26-171.91,87.24-8.39,1.12-16.82,1.98-25.23,2.96h-32c-5.94-.64-11.88-1.31-17.83-1.9-39.81-3.94-77.08-15.98-112.13-35.09-5.18-2.82-10.16-6.02-15.23-9.05,56.31,4.23,106.96-9.5,152.86-44.03-48.05-4.4-79.91-28.54-97.7-73.23,16.01,1.92,30.78,2.34,46.23-2.02-62.77-15.77-85.23-72.47-81.86-103.72,14.07,7.03,28.66,11.84,45.42,12.12C10.11,118.9,12.38,53.27,34.08,19.77c56.66,66.59,128.26,103.41,215.62,109.23-.61-7.45-1.37-14.06-1.66-20.69-1.93-44.35,25.95-86.26,67.78-101.37C324.34,3.88,333.4,2.28,342.21,0Z"/></g></svg>
            </CircularButton>

            <style jsx>{`
                svg {
                    fill: white;
                    height: 24px;
                }
            `}</style>
        </SmartLinkExternal>
    )
})

export default ShareTwitterLink